import { Load, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';

export const LoadSchema = new ModelSchema<Load>('load', {
  category: ModelCategory.ComponentDesignData,

  properties: {},
});
